module.exports = __webpack_public_path__ + "img/alibaba.ddd39945.svg";